import React from 'react';

import { SVGComponentProps } from './svg.types';

const WhiteBoardTriangleSVG = ({
  fill = 'currentColor',
  size = '32',
  stroke = 'currentColor',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="15"
        height="13"
        viewBox="0 0 15 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.85048 1.62451C7.13916 1.12451 7.86084 1.12451 8.14952 1.62451L13.3457 10.6245C13.6343 11.1245 13.2735 11.7495 12.6962 11.7495H2.30384C1.7265 11.7495 1.36565 11.1245 1.65433 10.6245L6.85048 1.62451Z"
          stroke="#55585E"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
};

export default WhiteBoardTriangleSVG;
